import { render, staticRenderFns } from "./h_bo.vue?vue&type=template&id=54e381b2&scoped=true&"
import script from "./h_bo.vue?vue&type=script&lang=js&"
export * from "./h_bo.vue?vue&type=script&lang=js&"
import style0 from "./h_bo.vue?vue&type=style&index=0&id=54e381b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e381b2",
  null
  
)

export default component.exports